// extracted by mini-css-extract-plugin
export default {"melodyVideo":"XM-z","isFullWidth":"YM-z","landingPageVideo":"ZM-z","play":"_M-z","iframeVideo":"aN-z","playHidden":"bN-z","fullwidth":"cN-z"};